import React from 'react';

import historyStyles from './AlmeHistory.styles';

import { withStyles, WithStyles, makeStyles, createStyles } from '@material-ui/core/styles';

import {
    Theme, Accordion, AccordionDetails, AccordionSummary,
    Typography, Container, Box,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AlmeHistoryConfig } from './AlmeHistoryConfig';
import { AlmeScrollButtonConfig } from '../AlmeScrollButton/AlmeScrollButtonConfig';
import { AlmeLiveChatResponseConfig } from '../LiveChat/AlmeLiveChatResponse/AlmeLiveChatResponseConfig';
import AlmeResponseConfigTool from '../AlmeResponse/AlmeIvaResponse/AlmeIvaResponseConfigTool';
import AlmeLiveChatResponseConfigTool from '../LiveChat/AlmeLiveChatResponse/AlmeLiveChatResponseConfigTool';
import AlmeScrollButtonConfigTool from '../AlmeScrollButton/AlmeScrollButtonConfigTool';
import { AlmeIvaResponseConfig } from '../AlmeResponse/AlmeIvaResponse/AlmeIvaResponseConfig';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
        },
    }),
);

interface AlmeHistoryConfigToolProps extends WithStyles<typeof historyStyles> {
    almeConfig: AlmeHistoryConfig;
    onConfigChange: (almeConfig: AlmeHistoryConfig) => void;
}

const AlmeHistoryConfigTool: React.FC<AlmeHistoryConfigToolProps> = (props: AlmeHistoryConfigToolProps) => {
    const classes = useStyles();

    const onResponseConfigChange = (ivaResponseConfig: AlmeIvaResponseConfig): void => {
        const historyConfig: AlmeHistoryConfig = {
            history: {
                ...props.almeConfig.history,
                response: {
                    ...props.almeConfig.history.response,
                    ivaResponse: {
                        ...ivaResponseConfig.ivaResponse,
                    },
                },
            },
        };
        props.onConfigChange(historyConfig);
    };

    const onScrollButtonConfigChange = (scrollButtonConfig: AlmeScrollButtonConfig): void => {
        const historyConfig: AlmeHistoryConfig = {
            history: {
                ...props.almeConfig.history,
                scrollButton: {
                    ...scrollButtonConfig.scrollButton,
                },
            },
        };
        props.onConfigChange(historyConfig);
    };

    const onLiveChatResponseConfigChance = (liveChatResponseConfig: AlmeLiveChatResponseConfig): void => {
        const historyConfig: AlmeHistoryConfig = {
            history: {
                ...props.almeConfig.history,
                liveChatResponse: {
                    ...liveChatResponseConfig.liveChatResponse,
                },
            },
        };
        props.onConfigChange(historyConfig);
    };

    return (
        <Box className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-alme-history-config-tool-content"
                    id="panel-alme-history-config-tool-header"
                >
                    <Typography variant='h6'>Alme History Config Tools</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Container>
                        <AlmeResponseConfigTool almeConfig={props.almeConfig.history.response} onConfigChange={onResponseConfigChange} />
                        <AlmeScrollButtonConfigTool almeConfig={props.almeConfig.history} onConfigChange={onScrollButtonConfigChange} />
                        <AlmeLiveChatResponseConfigTool almeConfig={props.almeConfig.history} onConfigChange={onLiveChatResponseConfigChance} />
                    </Container>
                </AccordionDetails>
            </Accordion>
        </Box >
    );
};

export default withStyles(historyStyles)(AlmeHistoryConfigTool);